import Image from "../../components/image/Image";
import { AppIcons } from "../../data/appIcons";
import "./Unauthorize.scss";

const Unauthorize = () => {
  return (
    <div className="center-content-part white-bg">
      <div className="content-desc-section no-margin-top">
        <div className="center-container unauthorized-section">
          <div className="left-text">
            <h1>Oops!</h1>
            <h4>Unauthorized Access</h4>
            <p>
              You are not authorized to access this page.<br />
              {/* Please Contact the administrator for Access. */}
            </p>
          </div>
          <div className="right-img">
            <Image
              imagePath={AppIcons.UnauthorizedImg}
              altText="Vector Image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorize;
